import { render, staticRenderFns } from "./DevTemplate.vue?vue&type=template&id=890f9ffe&scoped=true"
import script from "./DevTemplate.vue?vue&type=script&lang=js"
export * from "./DevTemplate.vue?vue&type=script&lang=js"
import style0 from "./DevTemplate.vue?vue&type=style&index=0&id=890f9ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f9ffe",
  null
  
)

export default component.exports